import {
  addDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { db } from "./firebaseConfig";

// ============================================================
// CREAR GARANTÍA EXTERNA
// ============================================================

const GarantiaExternaDB = async ({
  empId,
  idIngreso,
  idGarantia,
  ingreso,
  proveedor,
  usuario,
}) => {
  if (!empId) {
    throw new Error("Empresa no definida.");
  }

  if (!idIngreso) {
    throw new Error("Ingreso no definido.");
  }

  if (!idGarantia) {
    throw new Error(
      "Cabecera de garantía no definida."
    );
  }

  if (!proveedor?.id) {
    throw new Error(
      "Proveedor externo no definido."
    );
  }

  // ==========================================================
  // EVITAR DUPLICADOS
  // ==========================================================

  const qExiste = query(
    collection(db, "garantiasexternas"),
    where("emp_id", "==", empId),
    where("id_cab_inst", "==", idIngreso)
  );

  const snapExiste = await getDocs(qExiste);

  if (!snapExiste.empty) {
    return snapExiste.docs[0].id;
  }

  // ==========================================================
  // CREAR CASO
  // ==========================================================

  const now = new Date();

  const ref = await addDoc(
    collection(db, "garantiasexternas"),
    {
      // Relaciones
      emp_id: empId,

      id_cab_inst: idIngreso,

      id_cab_gar: idGarantia,

      folio_ingreso:
        ingreso?.folio ?? "",

      // Cliente
      cliente_rut:
        ingreso?.rut ?? "",

      cliente:
        ingreso?.entidad ?? "",

      // Equipo original
      familia:
        ingreso?.familia ?? "",

      tipo:
        ingreso?.tipo ?? "",

      marca:
        ingreso?.marca ?? "",

      modelo:
        ingreso?.modelo ?? "",

      serie:
        ingreso?.serie ?? "",

      // Proveedor
      proveedor_id:
        proveedor.id,

      proveedor:
        proveedor.nombre ?? "",

      proveedor_rut:
        proveedor.rut ?? "",

      proveedor_contacto:
        proveedor.contacto ?? "",

      proveedor_correo:
        proveedor.correo ?? "",

      proveedor_telefono:
        proveedor.telefono ?? "",

      // Estado inicial
      estado:
        "PENDIENTE_GESTION",

      // Reemplazo
      requiere_reemplazo:
        null,

      tipo_reemplazo: "",

      // Envío proveedor
      enviado_proveedor:
        false,

      fecha_envio_proveedor:
        null,

      // Recepción proveedor
      recibido_proveedor:
        false,

      fecha_recepcion_proveedor:
        null,

      // Cierre
      cerrado:
        false,

      fecha_cierre:
        null,

      // Auditoría
      useradd:
        usuario ?? "",

      usermod:
        usuario ?? "",

      fechaadd: now,

      fechamod: now,
    }
  );

  return ref.id;
};

export default GarantiaExternaDB;